$drinks-background: '#111C27' !default;
$drinks-color: '#B6CEE2' !default;
$drinks-header-color: '#B6CEE2' !default;
$drinks-border-color: '#22303F' !default;
$drinks-background1: '#182A38' !default;
$drinks-background2: '#2A475B' !default;
$drinks-background-color: '#192533' !default;

@mixin background {
  background: #{$drinks-background};
  border: 2px solid #{$drinks-border-color};
}

.drinks-row {
  .drinks-row-block1 {
    @include background;
    .col-md-custom {
      button {
        background: linear-gradient(0deg, #{$drinks-background1}, #{$drinks-background2});
        color: #{$drinks-color};
      }
      div {
        background-color: #{$drinks-background-color};
        color: #{$drinks-color};
        border: 2px solid #{$drinks-border-color};
        input {
          background-color: #{$drinks-background-color};
          color: #{$drinks-color};
        }
      }
    }
  }
  .drinks-row-block2 {
    @include background;
    div {
      span {
        color: #{$drinks-color};
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/drink-settings/drinks/drinks-theme.scss